var _excluded = ["content", "theme", "visible", "children", "interactive", "placement", "trigger", "onClickOutside", "hideOnClick", "maxWidth", "reference", "isWithoutWrapper", "classNames", "as", "className", "data-qa", "zIndex", "appendTo"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import Tippy, { useSingleton } from "@tippyjs/react";
import { zIndexSystem, joinCn } from "@ati/uti";
import styles from "./Tip.module.scss";
var zIndexDefault = {
  tip: zIndexSystem.tooltip // glz-z-tooltip
};
var defaultClassNames = {};
var Tip = _ref => {
  var {
      content,
      theme = "light",
      visible,
      children,
      interactive = true,
      placement = "auto",
      trigger,
      onClickOutside,
      hideOnClick = false,
      maxWidth = "none",
      reference,
      isWithoutWrapper = false,
      classNames = defaultClassNames,
      as: As = "span",
      className,
      "data-qa": dataQa = "tip",
      zIndex = zIndexDefault,
      appendTo
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (reference !== undefined) {
    return /*#__PURE__*/React.createElement(Tippy, _extends({}, rest, visible === undefined ? {
      hideOnClick
    } : {}, {
      className: [styles.tip, className].filter(Boolean).join(" "),
      onClickOutside: onClickOutside,
      trigger: trigger,
      content: content,
      maxWidth: maxWidth,
      placement: placement,
      theme: theme,
      visible: visible,
      interactive: interactive,
      reference: reference,
      "data-qa": dataQa,
      appendTo: appendTo,
      zIndex: zIndex.tip
    }));
  }
  var tippyChildren;
  if (isWithoutWrapper && React.isValidElement(children)) {
    tippyChildren = children;
  } else if (As != null && typeof As === "string") {
    tippyChildren = /*#__PURE__*/React.createElement(As, {
      className: classNames.wrapper
    }, children);
  }
  return /*#__PURE__*/React.createElement(Tippy, _extends({}, rest, visible === undefined ? {
    hideOnClick
  } : {}, {
    className: joinCn(styles.tip, classNames.tip, className),
    onClickOutside: onClickOutside,
    trigger: trigger,
    content: content,
    maxWidth: maxWidth,
    placement: placement,
    theme: theme,
    visible: visible,
    interactive: interactive,
    zIndex: zIndex.tip
  }), tippyChildren);
};
Object.defineProperty(Tip, "useSingleton", {
  get() {
    return useSingleton;
  }
});
export default Tip;